<template>
  <div class="menuFrame">
    <section id="login">
      <div class="container py-3">
        <div class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center">
          <a href="https://www.chanchao.com.tw/vn/">
            <div class="d-flex align-items-center">
              <img src="../../assets/images/ChanChaoLogo.png" class="navLogo mt-2" />
              <div class="mx-2 logoText text-dark font-weight-nomal">
                <div>Hội viên Chan Chao</div>
              </div>
            </div>
          </a>

          <div class="d-flex mr-3">
            <a href="https://www.chanchao.com.tw/accounts/forgetPw">
              <img src="../../assets/images/langTW.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
              <span class="navEnText text-muted mr-3"> 中文版 </span>
            </a>

            <a href="https://www.chanchao.com.tw/accounts/en/forgetPw">
              <img src="../../assets/images/lang.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
              <span class="navEnText text-muted mr-3"> English </span>
            </a>

            <a href="https://www.chanchao.com.tw/accounts/th/forgetPw">
              <img src="../../assets/images/th.svg" style="width: 17px; height: 17px" class="mb-1" />
              <span class="navEnText text-muted ml-1"> ภาษาไทย </span>
            </a>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row formFrame m-1 py-2">
          <div class="rightline col-md-7 my-4 px-4">
            <div class="d-flex align-items-center">
              <img src="../../assets/images/PwIcon.png" class="mr-2 mb-2" style="width: 40px; height: 40px" alt="" />
              <h4 class="title_family">Quên mật khẩu</h4>
            </div>
            <p class="my-4">
              Vui lòng nhập địa chỉ email bạn đã điền khi đăng ký tài khoản, chúng tôi sẽ gửi mật khẩu đến hộp thư của
              bạn ngay lập tức
            </p>
            <form>
              <div class="form-group h6">
                <label for="forgetpwEmail" class="title_family">Địa chỉ email</label>
                <input
                  type="email"
                  class="form-control"
                  id="forgetpwEmail"
                  maxlength="50"
                  aria-describedby="emailHelp"
                  placeholder="Vui lòng nhập địa chỉ email bạn đã điền khi đăng ký tài khoản"
                  v-model="email"
                  name="email"
                  :class="{ 'is-invalid': errors.first('email') }"
                  v-validate="'required|email'"
                  ref="forgetpwEmail"
                />
                <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('email')"
                  >{{ errors.first('email') }}
                </span>
              </div>

              <div class="form-group h6">
                <label for="forgetpwcode" class="title_family">Mã xác thực</label>
                <div class="d-flex justify-content-center align-items-center">
                  <input
                    type="text"
                    class="form-control mr-1"
                    id="forgetpwcode"
                    maxlength="5"
                    placeholder="Mã xác thực không phân biệt chữ hoa, chữ thường"
                    v-model="validcode"
                    name="text"
                    :class="{ 'is-invalid': errors.first('text') }"
                    v-validate="'required'"
                    ref="forgetpwcode"
                  />
                  <img
                    :src="getsrc"
                    class="img-fluid rounded"
                    @click.prevent="resetValidcode"
                    style="width: 120px; height: 35px"
                  />
                  <a href="#" @click.prevent="resetValidcode">
                    <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                  </a>
                </div>
                <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('text')"
                  >Mã xác thực không được để trống
                </span>
              </div>

              <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="getResetlink">
                Cài đặt lại mật khẩu
              </button>
            </form>

            <div v-if="!Registered">
              <hr />

              <div class="linkFrame">
                <a href="https://www.chanchao.com.tw/accounts/vn/login">Hội viên đăng nhập</a>

                <span class="linkText ml-2 pl-2">
                  <span class="linkLine"></span>
                  <a href="https://www.chanchao.com.tw/accounts/vn/signup">Đăng ký ngay</a>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-5 my-4 px-4 lineBottom">
            <div class="d-flex align-items-center mb-4">
              <i class="fas fa-2x fa-question-circle mr-3 mb-2" style="color: #ffa042"></i>
              <h4 class="title_family">Các câu hỏi thường gặp</h4>
            </div>
            <p style="font-weight: bold" class="title_family">Q: Vì sao tôi không nhận được email hoặc Mã xác nhận</p>
            <hr />

            <ol class="ml-0 pl-3">
              <li style="font-size: 15px" class="font-weight-bold title_family mb-3">
                Có phải đã bị phân loại vào 「Thư rác」hay không?
              </li>
              <p style="font-size: 14px">
                Vui lòng vào「Thư rác」 để kiểm tra xem có nhận được mail hay không. Nếu bạn tìm thấy, vui lòng chọn
                mail này và cài đặt là「Không phải thư rác」. Lần gửi tiếp theo, mail sẽ được gửi đến「Hộp thư đến」
              </p>

              <li style="font-size: 15px" class="font-weight-bold mb-3 title_family">
                Sau khi nhập email không nhận được Mã xác nhận?
              </li>
              <p style="font-size: 14px">
                Bạn có thể đợi vài phút để hệ thống gửi đi, nếu vẫn không nhận được thì có thể bạn đã nhập sai tài khoản
                email, xin vui lòng nhập và thử lại
              </p>

              <div class="d-flex mt-3">
                <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
                  >Câu hỏi thường gặp khác<i class="fas fa-external-link-alt ml-2"></i
                ></a>
              </div>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from '@/components/footer_en.vue'

  export default {
    components: {
      Footer,
    },

    data() {
      return {
        getsrc: '',
        email: '',
        validcode: '',
        alertTitle: '',
        alertText: '',
        lastUrl: '',
        CSRF_Token: '',
        Registered: false,
      }
    },

    watch: {
      email: function () {
        const vm = this
        vm.$refs.forgetpwEmail.style.borderColor = '#ced4da'
      },

      validcode: function () {
        const vm = this
        vm.$refs.forgetpwcode.style.borderColor = '#ced4da'
      },
    },

    methods: {
      getResetlink() {
        const vm = this
        if (vm.lastUrl.length === 0) {
          vm.lastUrl = 'https://www.chanchao.com.tw/vn/'
        }

        const linkinfo = {
          Email: vm.email,
          Validcode: vm.validcode,
          CSRF: vm.CSRF_Token,
        }

        const url = 'https://www.chanchao.com.tw/apiLogin2/forgetPw/vn'

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, linkinfo).then(function (response) {
              if (response.data == '200') {
                vm.alertTitle = 'Thành công'
                vm.alertText = 'Mật khẩu mới đã gửi đi thành công！'
                vm.alertSuccess()
              } else if (response.data == '252') {
                vm.alertText = 'Tài khoản của bạn đã bị ngưng sử dụng！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = 'Bạn chưa gia nhập hội viên！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = 'Địa chỉ email của bạn không đúng hoặc chưa gia nhập hội viên Chan Chao!！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '255') {
                vm.alertText = 'Xin vui lòng nhập địa chỉ email của bạn！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '256') {
                vm.alertText = 'Mã xác nhận không đúng, xin vui lòng nhập lại！'
                vm.alertError()
                vm.$refs.forgetpwcode.style.borderColor = 'red'
              } else if (response.data == '257') {
                window.location.replace('https://www.chanchao.com.tw/vn/')
              } else {
                vm.alertText = 'Hệ thống đang bận, vui lòng đăng nhập sau！'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Thông tin chưa hoàn thiện, xin vui lòng kiểm tra lại！'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this

        vm.$swal({
          // title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function () {
          document.location.href = 'https://www.chanchao.com.tw/accounts/vn/login'
        })
      },

      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },
    },

    created() {
      const vm = this
      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //更換英文語系
      vm.$i18n.locale = 'vi'

      //是否登入狀態

      //取cookie

      const url = 'https://www.chanchao.com.tw/apiLogin2/isAuthenticated'
      const info = null

      vm.$http.post(url, info).then(function (response) {
        // console.log(response.data)
        if (response.data == 200) {
          vm.Registered = true
        } else {
          vm.Registered = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  //Swal setting

  .logoText {
    font-size: 20px;
  }
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }
  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
    font-family: Arial;
  }

  .title_family {
    font-family: 'sans-serif';
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .rightline {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  .navLogo {
    height: 55px;
  }

  @media (max-width: 768px) {
    .rightline {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .navLogo {
      height: 50px;
    }
    .logoText {
      font-size: 16px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }
</style>
